import React from "react";
import PropTypes from "prop-types";
import { useNavigate, Link } from "react-router-dom";
import { withSearch, SearchBox } from "@elastic/react-search-ui";


// Reducer objects
import { CHANGE_SITE_INFO } from "../constants/actionTypes";

// Material UI Components
import AppBar from "@mui/material/AppBar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Toolbar from "@mui/material/Toolbar";
import Button from "@mui/material/Button";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import MenuIcon from "@mui/icons-material/Menu";
import SearchIcon from "@mui/icons-material/Search";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import EmailIcon from "@mui/icons-material/Email";
import InfoIcon from "@mui/icons-material/Info";
import SecurityIcon from "@mui/icons-material/Security";
import ListIcon from "@mui/icons-material/List";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import WarningIcon from "@mui/icons-material/Warning";
import LocalHospitalIcon from '@mui/icons-material/LocalHospital';
import GavelIcon from '@mui/icons-material/Gavel';

import { alpha } from "@mui/material/styles";

import makeStyles from '@mui/styles/makeStyles';

// Import logo
import logo from "../assets/logo_light.png";

// Styles
const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    justifyContent: "start",
    zIndex: 20,
    padding: 0,
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
  },
  toolbar: {
    minHeight: "50px !important",
    [theme.breakpoints.up("sm")]: {
      minHeight: "64px !important",
    },
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    fontFamily: "Black Ops One, Roboto",
    flexGrow: 1,
    display: "none",
    [theme.breakpoints.up("sm")]: {
      display: "block",
    },
  },
  search: {
    position: "relative",
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.25),
    "&:hover": {
      backgroundColor: alpha(theme.palette.common.white, 0.35),
    },
    marginLeft: "8px" ,
    width: "100%",
    [theme.breakpoints.up("md")]: {
      marginLeft: "auto",
      width: "auto",
      minWidth: "400px",
      fontSize: "1em",
    },
  },
  searchIcon: {
    width: theme.spacing(7),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
  },
  // CSS with search button
  // inputInput: {
  //   outline: "none",
  //   color: "#ffffff",
  //   fontWeight: 500,
  //   background: "inherit",
  //   border: "inherit",
  //   "&:focus": {
  //     border: "none",
  //     boxShadow: "none",
  //   },
  //   padding: theme.spacing(1, 1, 1, 7),
  //   transition: theme.transitions.create("width"),
  //   width: "100%",
  //   [theme.breakpoints.up("sm")]: {
  //     width: 400,
  //     "&:focus": {
  //       width: 400,
  //     },
  //   },
  // },
  inputInput: {
    fontSize: "1em",
    outline: "none",
    color: "#ffffff",
    background: "inherit",
    border: "inherit",
    "&:focus": {
      border: "none",
      boxShadow: "none",
    },
    padding: theme.spacing(1, 1, 1, 7),
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: 400,
      "&:focus": {
        width: 550,
      },
    },
  },
  logoimg: {
    height: "40px",
    width: "67.3px",
    marginRight: "6px"
  },
  link: {
    color: "#ffffff",
    textDecoration: "none",
  },
  menuPaper: {
    marginTop: "48px",
    [theme.breakpoints.up("sm")]: {
      marginTop: "60px",
    },
  },
  subscribeButton: {
    marginLeft: "16px",
    [theme.breakpoints.down('md')]: {
      display: "none",
    },
  },
}));

function Header({ setSearchTerm, dispatchSI, disableSearch }) {
  const classes = useStyles();

  const navigate = useNavigate();

  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = event => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  function handleItemSelect(page) {
    setAnchorEl(null);
    dispatchSI({type: CHANGE_SITE_INFO, payload: {open: true, page: page}});
  }

  const handleClearPage = () => {
    setSearchTerm("", { shouldClearFilters: true });
  };

  const goToDonate = () => {
    var newWindow = window.open();
    newWindow.opener = null;
    newWindow.location = 'https://donorbox.org/support-armalytics';
  };

  return (
    <div className={classes.root}>
      <AppBar position="static" color="primary">
        <Toolbar className={classes.toolbar}>
          <IconButton
            edge="start"
            className={classes.menuButton}
            color="inherit"
            aria-label="simple-menu"
            onClick={handleClick}
            size="large">
            <MenuIcon />
          </IconButton>
          <Menu
            id="simple-menu"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
            classes={{
              paper: classes.menuPaper,
            }}
          >
          <MenuItem onClick={() => handleItemSelect("banMessage")}>
            <ListItemIcon>
              <GavelIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary="Message on OICs" />
          </MenuItem>
            <MenuItem onClick={() => handleItemSelect("about")}>
              <ListItemIcon>
                <InfoIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="About" />
            </MenuItem>
            <MenuItem onClick={() => handleItemSelect("contact")}>
              <ListItemIcon>
                <EmailIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Contact" />
            </MenuItem>
            <MenuItem onClick={goToDonate}>
              <ListItemIcon>
                <LocalHospitalIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Donate" />
            </MenuItem>
            <MenuItem onClick={() => handleItemSelect("disclaimer")}>
              <ListItemIcon>
                <WarningIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Disclaimer" />
            </MenuItem>
            <MenuItem onClick={() => handleItemSelect("terms")}>
              <ListItemIcon>
                <ListIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Terms & Conditions" />
            </MenuItem>
            <MenuItem onClick={() => handleItemSelect("privacy")}>
              <ListItemIcon>
                <SecurityIcon fontSize="small" />
              </ListItemIcon>
              <ListItemText primary="Privacy Policy" />
            </MenuItem>
          </Menu>
          <div>
            <Link to="/" onClick={handleClearPage} className={classes.link} color="inherit">
              <img className={classes.logoimg} src={logo} alt="Logo" />
            </Link>
          </div>
          <div>
            <Link to="/" onClick={handleClearPage} className={classes.link}>
              <Typography className={classes.title} variant="h6" component="h1" noWrap>
                Armalytics
              </Typography>
            </Link>
          </div>
          {!disableSearch ? (
            <div className={classes.search}>
              <div className={classes.searchIcon}>
                <SearchIcon />
              </div>
              <SearchBox
                classname={classes.inputRoot}
                autocompleteMinimumCharacters={3}
                autocompleteResults={{
                  sectionTitle: "Results",
                  titleField: "model",
                  urlField: "url_field",
                  shouldTrackClickThrough: true,
                  clickThroughTags: ["autoresult"]
                }}
                autocompleteSuggestions={{
                  sectionTitle: "Suggestions",
                }}
                debounceLength={50}
                shouldClearFilters={false}
                inputProps={{id: "searchbar", className: classes.inputInput, placeholder: "Enter a make, model, classification, calibre, etc.."}}
              />
            </div>
          ) : (
            <>
              <div className={classes.search}>
              </div>
              <Button size="small" variant="text" color="inherit" onClick={() => navigate("/")}>
                FRT
              </Button>
            </>
          )}

          <Button size="small" variant="text" color="inherit" className={classes.subscribeButton} onClick={() => handleItemSelect("subscribe")}>
            Subscribe
          </Button>
        </Toolbar>
      </AppBar>
    </div>
  );
}

export default withSearch(({ setSearchTerm }) => ({
  setSearchTerm
}))(Header);

Header.propTypes = {
    children: PropTypes.element,
    setSearchTerm: PropTypes.func,
    dispatchSI: PropTypes.func,
    disableSearch: PropTypes.bool,
};
